
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersNightColour as ObiLightningLightRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-night-colour.js';
 
 
 

 
 export const ObiLightningLightRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-night-colour',
   elementClass: ObiLightningLightRainShowersNightColourElement,
   events: {
     
   }
  });
 
 